import React, { useState, useEffect, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import SklepProduktu from './SklepProduktu';
const DAO_PRODUKT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/produkt';
export default function ProduktSklepy(props) {
    const listaSklepow = props.listaSklepow;

    console.log("produkt w ProduktSklepy" + listaSklepow);

    let list;
    if(props.errorInfoProduktSklepy!=="")
    {
        return (<>Błąd: {props.errorInfoProduktSklepy}</>);
    }else if (listaSklepow.length === 0) {
        return (<>Brak sklepów</>);
    } else {
        list = listaSklepow.map((item, key) => {
            return (<SklepProduktu sklep={item}/>);
        });
    }
    return (
        <>
            <Table className="tabela-table" striped bordered hover size="sm">
                <tbody>
                    {list}
                </tbody>
            </Table>
        </>
    );
}
